export function getContrastTextColor(color) {
  try {
    let r, g, b;
    color = color.trim().toLowerCase();

    if (color.startsWith('#')) {
      const hex = color.slice(1);
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else if (hex.length === 6) {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
      } else {
        return '#000';
      }
    } else if (color.startsWith('rgb')) {
      const matches = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
      if (!matches || matches.length < 4) {
        return '#000';
      }
      r = parseInt(matches[1], 10);
      g = parseInt(matches[2], 10);
      b = parseInt(matches[3], 10);
    } else {
      return '#000';
    }

    const brightness = r * 0.299 + g * 0.587 + b * 0.114;
    return brightness < 150 ? '#fff' : '#000';
  } catch (err) {
    console.warn('getContrastTextColor fallback triggered:', err.message);
    return '#000';
  }
}
